import TransactionTypes from './TransactionTypes';

// transaction management
export function getPaymentHistoryPage (data) {
  return {
    type: TransactionTypes.GET_TRANSACTION_REQUEST,
    payload: data
  };
}
